import { SignIn, useUser, useAuth } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";
import { useEffect, useCallback } from "react";
import { AuthCard } from "@/components/auth/AuthCard";
import { clerkTheme } from "@/lib/clerk-theme";

export function Login() {
  const { isSignedIn } = useUser();
  const { getToken } = useAuth();
  const navigate = useNavigate();

  const checkVerificationStatus = useCallback(async () => {
    try {
      const token = await getToken();
      const apiUrl = import.meta.env.VITE_API_URL || "";
      const res = await fetch(`${apiUrl}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) {
        // API error - let user continue to onboarding
        navigate("/profile/photos");
        return;
      }

      const data = await res.json();

      // Verification is optional - redirect to feed/dashboard regardless of status
      // Unverified users can still use the app, just without premium privacy features
      if (data.profile?.profileCompletion === 100) {
        navigate("/feed");
      } else {
        // Profile incomplete - start onboarding
        navigate("/profile/photos");
      }
    } catch {
      // On error, let user continue to onboarding
      navigate("/profile/photos");
    }
  }, [getToken, navigate]);

  useEffect(() => {
    if (isSignedIn) {
      checkVerificationStatus();
    }
  }, [isSignedIn, checkVerificationStatus]);

  return (
    <AuthCard title="Welcome Back" description="Sign in to your account">
      <SignIn
        appearance={clerkTheme}
        signUpUrl="/register"
        routing="path"
        path="/login"
        afterSignInUrl="/feed"
        redirectUrl="/feed"
      />
    </AuthCard>
  );
}
